import * as React from "react";
// import SearchIcon from "@mui/icons-material/Search";
import { Button, Grid } from "@mui/material";
// import UploadIcon from "@mui/icons-material/Upload";
import { Formik, Form } from "formik";
import * as Yup from "yup";
import {
  makePostRequest,
  uploadFileRequest,
} from "../../../utils/utils";
import swal from "sweetalert";
import FileUploadIcon from "@mui/icons-material/FileUpload";
import Zoom from "react-medium-image-zoom";
import DoneIcon from "@mui/icons-material/Done";
import DeleteForeverIcon from "@mui/icons-material/DeleteForever";

const Validation_Schema_vehicle = Yup.object().shape({
  // vehicleType:Yup.string()
  // .required("Required"),
  ownername: Yup.string()
    .trim("White spaces not allow")
    .strict(true)
    .required("Required")
    .matches(
      /^([A-Za-z\u00C0-\u00D6\u00D8-\u00f6\u00f8-\u00ff\s]*)$/gi,
      "Numbers/Special Characters Not Allowed!!"
    ),
  vehicleno: Yup.string()
    .matches(
      /^[A-Z]{2}[0-9]{2}[A-HJ-NP-Z]{1,2}[0-9]{4}$/,
      "Vehicle No like eg.MH17BQ4125 "
    )
    .required("Required"),
});

function AddVehicleModal() {
  // const addCommitee = () => {
  //   var element = document.getElementById("successfullAdd");
  //   element.classList.toggle("hideModal");
  // };

  var formikInitials_vehicle = {
    // vehicleType:"",
    ownername: "",
    registrationno: "",
    vehicleno: "",
  };
  // }

  const [pdfImage] = React.useState(
    require("../../../assets/Images/pdf.png")
  );
  const [txtImage] = React.useState(
    require("../../../assets/Images/text.png")
  );
  const [excelImage] = React.useState(
    require("../../../assets/Images/exel.png")
  );
  const [wordImage] = React.useState(
    require("../../../assets/Images/doc.png")
  );

  const [ownername, setownername] = React.useState("");
  const [, setregistrationno] = React.useState("");
  const [vehicleno, setvehicleno] = React.useState("");
  const [vehicleType, setVehicleType] = React.useState("");
  const [edvehiflg, setedvehiflg] = React.useState(false);
  const [vehicleeditid, setvehicleeditid] = React.useState("");
  const [showLoader, setShowLoader] = React.useState(false);
  const [vehicleDocumentsList, setVehicleDocumentsList] = React.useState([]);
  const [vehDocErrorMsg, setVehDocErrorMsg] = React.useState("");
  const [Upload, setUpload] = React.useState(false);

  const [vehicleTypeErrMsg, setVehicleTypeErrMsg] = React.useState("");


  const handlechangeVehicleType = (e) => {
    setVehicleType(e.target.value);
  };

  async function handleCancelVehicle() {
    setedvehiflg(false);
    setvehicleeditid("");
    setownername("");
    setregistrationno("");
    setvehicleno("");
    setVehicleType("");
    setVehicleDocumentsList("");
  }

  async function uploadImageOrFile(fileData) {
    setShowLoader(true);
    const formData = new FormData();
    formData.append("image", fileData);
    var fileUrl;

    await uploadFileRequest("guards/uploadImages", formData).then(
      (response) => {
        fileUrl = response.data.imagepath[0].location;
      }
    );
    setShowLoader(false);
    // alert("File 2" + fileUrl);
    return fileUrl;
  }

  function validateImageOrFile(fileData) {
    if (
      fileData.name.match(
        /.(jpg|JPG|jpeg|JPEG|png|PNG|gif|GIF|docx|DOCX|doc|DOC|pdf|PDF|xls|XLS|txt|TXT|xlsx|XLSX)$/i
      )
    )
      return true;
    else return false;
  }

  async function uploadDocuments(e) {
    setVehDocErrorMsg("");
    setShowLoader(true)
    const file = e.target.files[0];
    if (validateImageOrFile(file)) {
      var profilePicUrl = await uploadImageOrFile(file);

      vehicleDocumentsList.push(profilePicUrl);
      setVehicleDocumentsList(vehicleDocumentsList);
    } else {
      setShowLoader(false)
      setVehDocErrorMsg("Invalid file format");
    }
    setShowLoader(false)
  }

  async function deleteDocument(userType, index) {
    vehicleDocumentsList.splice(index, 1);
    setVehicleDocumentsList(vehicleDocumentsList);

    setUpload(!Upload);
  }
  
  //add vehicle and edit vehicle
  async function addvehicle() {
    
    
    if (vehicleType === "") {
      setVehicleTypeErrMsg("Required");
    } else {
      setVehicleTypeErrMsg("");
      if (!edvehiflg) {
        setShowLoader(true);
        let inputdata = {
          vehicle_id: vehicleeditid,
          service_provider_id: localStorage.getItem('service_provider_id'),
          // reg_no: registrationno,
          vehicle_no: vehicleno,
          vehicle_type: vehicleType,
          vehicle_owner_name: ownername,
          document_list: vehicleDocumentsList,
        };
        await makePostRequest("serviceProviderVehicle/update", inputdata)
          .then((response) => {
            // checked codition if responce is empty
            if (response.data.data !== undefined) {
              setownername("");
              setvehicleno("");
              setregistrationno("");
              setVehicleDocumentsList([]);
              setVehicleType("");
              setedvehiflg(false);
              setvehicleeditid("");
              swal(
                "Success",
                "Vehicle Information Updated Successfully",
                "success",
                {
                  timer: 1000,
                  buttons: false,
                }
              );
              localStorage.setItem("tabName",'Vehicle Details');
              window.location.reload();
            } 
            setShowLoader(false);
          })
          .catch((err) => {
            setShowLoader(false);
            swal("There was an error!", "more error details", "warning");
          });
      } else {
        // if (propsResidentId > 0) {
        //   residentId = propsResidentId;
        // } else {
        //   residentId = localStorage.getItem("residentid");
        // }
        let vehicleAdded = false;
        setShowLoader(true);
        let inputdata = {
          service_provider_id: localStorage.getItem('service_provider_id'),
          // reg_no: registrationno,
          vehicle_no: vehicleno,
          vehicle_owner_name: ownername,
          vehicle_type: vehicleType,
          document_list: vehicleDocumentsList,
        };
        await makePostRequest("serviceProviderVehicle/insert", inputdata)
          .then((response) => {
            console.log("Vehicle Data " + response.data.data);
            if (response.data.data != undefined) {
              setownername("");
              setvehicleno("");
              setregistrationno("");
              setVehicleDocumentsList([]);

              vehicleAdded = true;
              localStorage.setItem("tabName",'Vehicle Details');
              window.location.reload();
            } 
            setShowLoader(false);
          })
          .catch((err) => {
            setShowLoader(false);
            swal("There was an error!", "more error details", "warning");
          });

      
      }
    }
  }

  React.useEffect(() => {
   
  }, [Upload]);

  return (
    <>
      <div id="successfullAdd">
        <Grid container spacing={3} className="addCommitee1">
          <Grid item xs={12} md={12}>
            <Formik
              enableReinitialize
              initialValues={formikInitials_vehicle}
              validationSchema={Validation_Schema_vehicle}
              onSubmit={addvehicle}
            >
              {({
                values,
                handleChange,
                errors,
                setFieldTouched,
                touched,
                isValid,
                handleSubmit,
              }) => (
                <Form>
                  <Grid container spacing={3}>
                    <Grid item xs={12} md={6}>
                      <Grid container spacing={2}>
                        <Grid item xs={12} md={12}>
                          <label className="tabsLabel">
                            Vehicle Type <span style={{ color: "red" }}>*</span>
                          </label>
                          <select
                            id="residentTypeList"
                            className="inputSt"
                            value={vehicleType}
                            onChange={handlechangeVehicleType}
                          >
                            <option value="">Vehicle Type</option>
                            <option value="Two Wheeler">Two Wheeler</option>
                            <option value="Four Wheeler">Four Wheeler</option>
                          </select>
                          {errors.vehicleType && touched.vehicleType ? (
                            <div
                              style={{ color: "red" }}
                              className="errorField"
                            >
                              {errors.vehicleType}
                            </div>
                          ) : (
                            <div
                              style={{ color: "red" }}
                              className="errorField"
                            >
                              {vehicleTypeErrMsg}
                            </div>
                          )}
                        </Grid>
                        <Grid item xs={12} md={12}>
                          <label className="tabsLabel">
                            Owner Name <span style={{ color: "red" }}>*</span>
                          </label>
                          <input
                            className="inputSt"
                            placeholder="Owner Name"
                            value={values.ownername}
                            onChange={handleChange("ownername")}
                            onBlur={() => setFieldTouched("ownername")}
                            onChangeCapture={(e) =>
                              setownername(e.target.value)
                            }
                          />
                          {errors.ownername && touched.ownername ? (
                            <div
                              style={{ color: "red" }}
                              className="errorField"
                            >
                              {errors.ownername}
                            </div>
                          ) : null}
                        </Grid>
                        {/* <label className="tabsLabel">
                                        Registration Number
                                      </label>
                                      <input
                                        className="inputSt inputStForAdVehicle"
                                        placeholder="Registration Number"
                                        value={values.registrationno}
                                        onChange={handleChange(
                                          "registrationno"
                                        )}
                                        onBlur={() =>
                                          setFieldTouched("registrationno")
                                        }
                                        onChangeCapture={(e) =>
                                          setregistrationno(e.target.value)
                                        }
                                      /> */}
                        {/* {errors.registrationno &&
                                      touched.registrationno ? (
                                        <div
                                          style={{ color: "red" }}
                                          className="errorField"
                                        >
                                          {errors.registrationno}
                                        </div>
                                      ) : null} */}
                        <Grid item xs={12} md={12}>
                          <label className="tabsLabel">
                            Vehicle Number{" "}
                            <span style={{ color: "red" }}>*</span>
                          </label>
                          <input
                            className="inputSt"
                            placeholder="Vehicle Number"
                            value={values.vehicleno}
                            onChange={handleChange("vehicleno")}
                            onBlur={() => setFieldTouched("vehicleno")}
                            onChangeCapture={(e) =>
                              setvehicleno(e.target.value)
                            }
                          />
                          {errors.vehicleno && touched.vehicleno ? (
                            <div
                              style={{ color: "red" }}
                              className="errorField"
                            >
                              {errors.vehicleno}
                            </div>
                          ) : null}
                        </Grid>
                      </Grid>
                    </Grid>

                    <Grid item xs={12} md={6}>
                      <div className="tabViewOfProviderRight">
                        <h4 className="doquProviderHed">Documents</h4>
                        <div className="societyDoc">
                          <h4 className="documeUpload documeUploadIcon">
                            Upload Documents
                            <Button className="forUploadOnly">
                              <FileUploadIcon />
                              <input
                                type="file"
                                id="vehicleDocumentsList"
                                value={values.vehicleDocumentsList}
                                onChange={(event) =>
                                  uploadDocuments(event)
                                }
                              />
                            </Button>
                          </h4>
                        </div>
                        {vehDocErrorMsg ? (
                          <div className="errorField errorFieldFForLogin forInvalidFile">
                            {vehDocErrorMsg}
                          </div>
                        ) : (
                          <></>
                        )}

                        {vehicleDocumentsList ? (
                          <>
                            <div className="docScrollBar">
                              {vehicleDocumentsList.map((option, index) => (
                                <div className="doqumentDiv1">
                                  <Zoom>
                                    <div className="doquView">
                                      {option.split(".").pop() == "txt" ? (
                                        <img src={txtImage} />
                                      ) : option.split(".").pop() == "pdf" ? (
                                        <img src={pdfImage} />
                                      ) : option.split(".").pop() == "docx" ||
                                        option.split(".").pop() == "doc" ? (
                                        <img src={wordImage} />
                                      ) : option.split(".").pop() == "xls" ||
                                        option.split(".").pop() == "xlsx" ? (
                                        <img src={excelImage} />
                                      ) : (
                                        <img src={option} />
                                      )}
                                    </div>
                                  </Zoom>
                                  <span>
                                    {option
                                      .split("/")
                                      .pop()
                                      .replace("%20", " ")}
                                    <DoneIcon />
                                  </span>
                                  {/* onclick={option=>deleteDocument(option,'resident')} */}
                                  <Button
                                    className="documRemove"
                                    onClick={() =>
                                      deleteDocument("vehicle", index)
                                    }
                                  >
                                    <DeleteForeverIcon />
                                  </Button>
                                </div>
                              ))}
                            </div>
                          </>
                        ) : (
                          <span>No Documents Uploaded yet</span>
                        )}
                      </div>
                    </Grid>

                    <Grid item xs={12} md={12}>
                      <Grid container spacing={3}>
                        <Grid item xs={12} md={6}>
                          {edvehiflg ? (
                            <Button
                              className="addBt cancelBtForAll forFullWidthCancelBt"
                              onClick={handleCancelVehicle}
                            >
                              Cancel
                            </Button>
                          ) : (
                            <></>
                          )}
                        </Grid>
                        <Grid item xs={12} md={6}>
                          <Button className="addApBt" type="submit">
                            {edvehiflg == true ? (
                              <div> Edit Vehicle</div>
                            ) : (
                              <div>Add Vehicle</div>
                            )}
                          </Button>
                        </Grid>
                      </Grid>
                    </Grid>
                  </Grid>
                </Form>
              )}
            </Formik>
          </Grid>
        </Grid>

        <Grid container spacing={3} className="addCommitee2">
          <Grid item xs={12} md={12}>
            <div className="succesMain">
              <img src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTfz3upZJUzgki4bn27faJf6gPIIo7Yo5HxZg&usqp=CAU" alt="altimg"/>
              <h4>Success !</h4>
              <p>
                Vehicle added <br />
                successfully
              </p>
            </div>
          </Grid>
        </Grid>
      </div>

      {showLoader ? (
        <div className="loaderOter" id="loaderId">
          <div className="wrapper">
            <div className="circle"></div>
            <div className="circle"></div>
            <div className="circle"></div>
            <div className="shadow"></div>
            <div className="shadow"></div>
            <div className="shadow"></div>
            <span>Loading</span>
          </div>
        </div>
      ) : (
        <></>
      )}
      
    </>
  );
}
export default AddVehicleModal;
